import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDRW6nYsNzlHf7uxze6rOvH9dH-oBqaksM",
  authDomain: "postproperty-30ca2.firebaseapp.com",
  projectId: "postproperty-30ca2",
  storageBucket: "postproperty-30ca2.firebasestorage.app",
  messagingSenderId: "820301903946",
  appId: "1:820301903946:web:31cc19a7bb31c960a60eb3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export instances
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

// Enhancement: Database reference helpers
export const COLLECTIONS = {
  LEADS: 'leads',
  VISITS: 'visits',
  PROPERTIES: 'properties',
  SITE_SETTINGS: 'site_settings',
  TESTIMONIALS: 'testimonials',
  BLOG: 'blog'
} as const;

export default app;
